<template>
  <ui-card class="comment-box">
    <ui-avatar
      :url="comment.userInfo.avatar"
      :username="comment.userInfo.username"
      >{{ $d(new Date(comment.created), "long") }}</ui-avatar
    >
    <template v-if="!comment.isDeleted">
      <div class="comment-actions" v-if="isAuthor">
        <ui-icon
          name="icon-delete"
          @click.native="del"
          class="pointer"
        ></ui-icon>
      </div>
      <div class="comment-content">{{ comment.comment }}</div>
    </template>
    <div v-else class="deleted">{{ $t("commentDeleted") }}</div>
  </ui-card>
</template>
<script>
import api from "../../api/index";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  props: ["comment"],
  computed: {
    ...mapGetters(["authInfo"]),
    isAuthor() {
      return (
        this.authInfo &&
        (this.comment.userId._id == this.authInfo.id ||
          this.comment.aid == this.authInfo.id)
      );
    }
  },
  methods: {
    del() {
      this.$UiModal({
        title: this.$t("deleteCommentConfirm"),
        message: this.$t("deleteCommentMessage"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("delete"),
        onConfirm: () => {
          api
            .delComment(this.comment._id)
            .then(res => {
              this.comment.isDeleted = true;
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  }
};
</script>
